import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, Alert as MUIAlert, Slide, Snackbar as MUISnackbar, } from "@mui/material";
import { Button } from "../Button";
import { Icon } from "../Icon";
import { IconButton } from "../IconButton";
import { convertPxToRem } from "../../util-functions";
const StyledSnackbar = styled(MUISnackbar)(({ theme }) => ({
    "& .MuiSnackbarContent-root": {
        borderRadius: convertPxToRem(15),
    },
    ".MuiSnackbarContent-message": Object.assign({}, theme.typography.mediumText),
}));
const StyledAlert = styled(MUIAlert, {
    shouldForwardProp: (prop) => prop !== "severity",
})(({ theme, severity }) => ({
    "&.MuiPaper-root": {
        backgroundColor: severity === "error"
            ? theme.palette.error.main
            : severity === "warning"
                ? theme.palette.warning.main
                : theme.palette.primaryBlack.main,
        boxSizing: "border-box",
        height: convertPxToRem(52),
        "&.MuiAlert-root": {
            color: theme.palette.primaryWhiteText.main,
            borderRadius: convertPxToRem(15),
        },
    },
    "& .MuiAlert-action": {
        paddingTop: 0,
        ".MuiButtonBase-root": {
            color: theme.palette.sativaGreen.main,
            height: "100%",
            textDecoration: "none",
            textTransform: "capitalize",
            "> p": Object.assign({ textDecoration: "none" }, theme.typography.mediumText),
            ":hover": {
                backgroundColor: "transparent",
            },
            "> span": {
                color: theme.palette.primaryWhiteText.main,
            },
        },
    },
    "& .MuiAlert-message, & .MuiAlert-icon": {
        display: "flex",
        alignItems: "center",
    },
    "& .MuiAlert-message": {
        whiteSpace: "nowrap",
    },
}));
const SlideUp = (props) => _jsx(Slide, Object.assign({}, props, { direction: "up" }));
export const Snackbar = ({ iconName, message, onClick, onClose, open, severity = "info", testId, textButton, }) => {
    const shortenedMessage = message.length > 60 ? message.substring(0, 60) : message;
    const shortenedTextButton = textButton && textButton.length > 10
        ? textButton.substring(0, 10)
        : textButton;
    const handleTextButton = () => {
        onClick === null || onClick === void 0 ? void 0 : onClick();
        onClose();
    };
    const action = (_jsxs(_Fragment, { children: [shortenedTextButton && severity === "info" && (_jsx(Button, { variant: "text", label: shortenedTextButton, onClick: handleTextButton })), _jsx(IconButton, { variant: "secondary", size: "small", iconName: "Close", onClick: onClose })] }));
    const chooseIcon = () => {
        if (severity === "warning") {
            return _jsx(Icon, { iconName: "Warning", color: "primaryWhite" });
        }
        if (severity === "error") {
            return _jsx(Icon, { iconName: "Error", color: "primaryWhite" });
        }
        if (severity === "info" && iconName) {
            return _jsx(Icon, { iconName: iconName, color: "primaryWhite" });
        }
        return false;
    };
    return (_jsx(StyledSnackbar, Object.assign({ "data-testid": testId, autoHideDuration: severity === "error" ? null : 8000, open: open, onClose: onClose, anchorOrigin: { vertical: "bottom", horizontal: "center" }, TransitionComponent: SlideUp }, { children: _jsx(StyledAlert, Object.assign({ "data-testid": testId && `alert-${testId}`, severity: severity, icon: chooseIcon(), action: action }, { children: shortenedMessage })) })));
};
